import { render, staticRenderFns } from "./PendingPrescriptions.vue?vue&type=template&id=6f81fc7a&scoped=true&"
import script from "./PendingPrescriptions.vue?vue&type=script&lang=js&"
export * from "./PendingPrescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f81fc7a",
  null
  
)

export default component.exports